
import { SMUser } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Error404 extends Vue {
  async goHome() {
    const home = SMUser.isExpert ? "cases" : "home";

    let path = SMUser.basePath ? `${SMUser.basePath}/${home}` : "/auth/login";
    if (SMUser.isCandidate) path = "/cases";

    try {
      await this.$router.push(path);
    } catch {
      return;
    }
  }
}
